<template>
   <el-popover
    placement="bottom"
    width="600"
    trigger="hover">

    <div v-if="ticketOrigin">
        <div>
            <b>ID:</b>
            <span>{{ticketOrigin.id}}</span>
        </div>
        <div>
            <b>IP:</b>
            <span>{{ticketOrigin.remoteAddr}}</span>
        </div>
        <div>
            <b>Referer:</b>
            <span>{{ticketOrigin.referer}}</span>
        </div>
        <div>
            <b>UserAgent:</b>
            <span>{{ticketOrigin.userAgent}}</span>
        </div>
        <div>
            <b>创建于:</b>
            <span>{{ticketOrigin.createdAt}}</span>
        </div>
    </div>

    <div v-else style="min-height:100px;text-align:center;font-size:75px;color:#d0d0d0;">未 知 {{ticketOrigin}}</div>

    <div slot="reference" class="ticketOrigin_0">
        <UserAgent v-model="ticketOrigin"/>
    </div>
  </el-popover>
</template>

<style>
    .ticketOrigin_0 {
        color: #9b9b9b;
        padding: 0 3px;
        border-radius: 3px;
        border: 1px solid #f5f1f1;
        display: inline;
    }
</style>

<script>
export default {
    name : 'TicketOrigin',

    props : ['value'],

    data() {
        return {
            ticketOrigin : {}
        }
    },

    watch : {
        value() {
            this.onValue();
        }
    },

    methods : {
        onValue() {
            var _this = this;

            if ( !window.TicketOriginList ) {
                window.TicketOriginList = [];
            }

            window.TicketOriginList.push(this);

            clearTimeout(window.TicketOriginTimeoutId);
            window.TicketOriginTimeoutId = setTimeout(this._doLoad, 500);
        },

        _doLoad() {
            var _this = this;

            if ( !window.TicketOriginList || window.TicketOriginList.length < 1 ) {
                clearTimeout(window.TicketOriginTimeoutId);
                window.TicketOriginTimeoutId = setTimeout(this._doLoad, 1500); // 太快了？
                return;
            }

            sdk.TicketOriginApi().listByIds({
                ids : window.TicketOriginList.map(e => e.value)
            }).then(res=> {
                var len = window.TicketOriginList ? window.TicketOriginList.length : 0;

                for ( var i=0; i < len; i++ ) {
                    var _each = window.TicketOriginList[i];
                    var _that = _this.findById(res, _each.value);
                    _each.ticketOrigin = _that;
                }

                // 清理
                window.TicketOriginTimeoutId = null;
                window.TicketOriginList = null;
            });
        },

        findById(list, id) {
            for ( var i=0; i < list.length; i++ ) {
                if(list[i].id + "" == id + "" ) {
                    return list[i];
                }
            }

            return null;
        }
    },

    mounted() {
        this.onValue();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketOrigin.vue